import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container mx-auto pt-8 pb-16 px-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-gray-100 text-3xl font-semibold pt-2" }, " New Lock ", -1)
const _hoisted_3 = { class: "bg-white text-gray-700 p-4 mt-8 rounded-md shadow-md" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mb-1 text-sm" }, "Date range:", -1)
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "inline-flex items-center px-3 border border-r-0 rounded-l-md border-gray-200 bg-gray-50 text-gray-500 text-sm" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mb-1 text-sm" }, "Lock reason:", -1)
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "mt-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "mb-1 text-sm" }, "Violatable by:", -1)
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "ml-2 text-sm capitalize" }
const _hoisted_18 = { class: "flex mt-4 justify-end" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Save lock", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_app_button = _resolveComponent("app-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Loading. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_date_picker, {
              modelValue: _ctx.date,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
              masks: {input: 'D. M. YYYY'},
              popover: { visibility: 'focus' },
              "is-range": ""
            }, {
              default: _withCtx(({ inputValue, inputEvents, isDragging }) => [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_component_CalendarIcon, { class: "h-5 w-5" })
                    ]),
                    _createElementVNode("input", _mergeProps({
                      readonly: "",
                      class: ["flex-grow px-3 py-2 w-full rounded-md rounded-l-none border border-gray-200 text-sm text-gray-700", isDragging ? 'text-gray-500' : 'text-gray-700'],
                      value: _ctx.date.start && _ctx.date.end ? (inputValue.start + ' - ' + inputValue.end) : 'Select range'
                    }, _toHandlers(inputEvents.start)), null, 16, _hoisted_10)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "masks"]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedLockReason) = $event)),
                class: "form-select appearance-none w-full rounded-md text-sm text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-200"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lockReasons, (lockReason) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: lockReason.id,
                    value: lockReason.id
                  }, [
                    _createElementVNode("span", null, _toDisplayString(lockReason.name), 1)
                  ], 8, _hoisted_13))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedLockReason]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: role,
                  class: "mb-1 flex items-center"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedRoles) = $event)),
                    type: "checkbox",
                    value: role.name,
                    class: "form-checkbox rounded-sm focus:ring-0 border-gray-300"
                  }, null, 8, _hoisted_16), [
                    [_vModelCheckbox, _ctx.selectedRoles]
                  ]),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(role.name), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_app_button, {
                onClick: _ctx.onSubmit,
                type: "blue",
                class: _normalizeClass(['w-full sm:w-auto'])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CheckIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                  _hoisted_19
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
    ])
  ]))
}